export default "__VITE_ASSET__jskL1otA__"